import { Transition } from "@headlessui/react"
import clsx from "clsx"
import PropTypes from "prop-types"
import Spinner from "../Spinner"
export default function Snackbar({
  open,
  message,
  action,
  setOpenSnackbar,
  isLoading,
  className,
  actionClassName,
}) {
  return (
    <Transition
      show={open}
      enter="transition duration-300 ease-out transform"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition duration-300 ease-in transform"
      leaveFrom="translate-y-0 opacity-100 sm:translate-x-0"
      leaveTo="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      className={clsx(
        "fixed z-50 bottom-5 md:right-10 flex justify-center md:justify-end w-full",
        className && className,
      )}
    >
      <div className="bg-primary p-4 rounded-md !text-white text-sm optimistic w-fit md:w-fit">
        <div className="flex items-center">
          <span>{message}</span>
          <button
            id="save-seo"
            disabled={isLoading}
            onClick={action}
            className={clsx(
              "mx-4 text-brand-secondary uppercase flex justify-center",
              actionClassName && actionClassName,
            )}
          >
            {isLoading ? <Spinner color="white" height="10px" /> : "save"}
          </button>
          <button
            onClick={() => {
              setOpenSnackbar(false)
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 ml-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </Transition>
  )
}

Snackbar.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  setOpenSnackbar: PropTypes.func,
  isLoading: PropTypes.bool,
  action: PropTypes.func,
  className: PropTypes.string,
  actionClassName: PropTypes.string,
  ref: PropTypes.object,
}
